// Bender-Tiefenstufen — Single Source of Truth fürs Frontend.
// Pendant zu app/core/depth_labels.py. Wenn das Label-Set später umbenannt
// wird (Carina-Pivot, BACKLOG), reicht eine Änderung an dieser Stelle plus
// die Backend-Konstante.

export const DEPTH_LABELS = ["Wissen", "Verstehen", "Können", "Performanz"] as const;
export type DepthLabel = (typeof DEPTH_LABELS)[number];
